import { SkillCard } from "./SkillCard";

const skills = [
  { name: "HTML", image: "html.svg" },
  { name: "CSS", image: "css.svg" },
  { name: "JavaScript", image: "js.svg" },
  { name: "React", image: "react.svg" },
  { name: "Redux", image: "redux.svg" },
  { name: "Node", image: "node.svg" },
  { name: "MongoDB", image: "mongo.svg" },
  { name: "Express", image: "express.svg" },
  { name: "Git", image: "git.svg" },
  { name: "MUI", image: "mui.svg" },
];

export const Skills = () => {
  return (
    <div>
      <SkillCard skills={skills} />
    </div>
  );
};
